type ExcelBrandTemplateListener = () => void;

let activeExcelBrandTemplateId = "";
const listeners = new Set<ExcelBrandTemplateListener>();

export function getActiveExcelBrandTemplateId(): string {
  return activeExcelBrandTemplateId;
}

export function setActiveExcelBrandTemplateId(value: string): void {
  const nextValue = value.trim();
  if (nextValue === activeExcelBrandTemplateId) return;

  activeExcelBrandTemplateId = nextValue;
  listeners.forEach((listener) => listener());
}

export function resetActiveExcelBrandTemplateId(): void {
  setActiveExcelBrandTemplateId("");
}

export function subscribeExcelBrandTemplate(listener: ExcelBrandTemplateListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
